import React from "react";

// core components
import { connect } from 'react-redux'
import PropTypes from "prop-types";
import { bindActionCreators }  from 'redux';
import { withRouter } from "react-router-dom";

import { getDeletedObjects, restoreObjects } from "api/actions";

import { withoutAuth, withSearch, withPreview } from "HOC"

import {
  GET_DELETED_OBJECTS,
  GET_DELETED_OBJECTS_SUCCESS,
  GET_DELETED_OBJECTS_FAILURE,
  RESTORE_OBJECTS,
  RESTORE_OBJECTS_SUCCESS,
  RESTORE_OBJECTS_FAILURE
} from '../../constants/ActionTypes'

import './index.css'
import TruncateLine from "components/TruncateLine";

import MainView from './MainView';

class RecentlyDeleted extends React.Component {
  state = {
    hoveringOver: null,
    data: []
  };

  componentWillMount() {
    this.setState({ data: [] });
  }

  async componentWillReceiveProps(nextProps) {
    switch (nextProps.type) {
      case GET_DELETED_OBJECTS:
        this.setState({ loading: true, data: [] });
        break;
      case GET_DELETED_OBJECTS_SUCCESS:
        this.setState({ loading: false, data: nextProps.deletedObjects });
        break;
      case GET_DELETED_OBJECTS_FAILURE:
        this.setState({ loading: false });
        break;
      case RESTORE_OBJECTS:
        await this.startLoading();
        break;
      case RESTORE_OBJECTS_SUCCESS:
      await this.stopLoading();

        const { data } = this.state;

        this.setState({
          data: data.filter(object => !nextProps.restoredIds.includes(object.id)),
        });
        break;
      case RESTORE_OBJECTS_FAILURE:
        await this.stopLoading();
        break;      
    }
  }

  getDeletedObjects = (info = {}) => {
    this.props.getDeletedObjects(info);
  };

  restoreObjects = (info = {}) => {
    this.props.restoreObjects(info);
  };

  startLoading = () => new Promise(resolve => this.setState({ loading: true }, resolve));

  stopLoading = () => new Promise(resolve => this.setState({ loading: false }, resolve));

  render() {
    return (
      <MainView
        objects={this.state.data}
        location={this.props.location}
        loading={this.state.loading}
        page={this.state.page}
        getDeletedObjects={this.getDeletedObjects}
        restoreObjects={this.restoreObjects}
        restoredIds={this.props.restoredIds}
        type={this.props.type}
        addNotification={this.props.addNotification}
        errors={this.props.errors}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  errorMessage: state.errorMessage,
  deletedObjects: state.deletedObjects,
  restoredIds: state.restoredIds,
  errors: state.errors,
  type: state.type,
});

const dispatchToProps = (dispatch) => {
  return bindActionCreators({ restoreObjects, getDeletedObjects }, dispatch)
};


export default connect(mapStateToProps, dispatchToProps)(
  withRouter(
    RecentlyDeleted
  )
)
